<mat-toolbar color="primary">
    <span>Impression</span>
    <span class="toolbar-spacer"></span>
</mat-toolbar>
<mat-dialog-content>
<div>
    <app-printers (selected)="selectPrinter($event)"></app-printers>
    <button mat-stroked-button class="full-width" (click)="pdf()">Créer un PDF</button>
</div>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="close()">Fermer</button>
    <button mat-button (click)="print()">Imprimer</button>
</mat-dialog-actions>